export default __webpack_public_path__ + "static/media/service-3.2c981e0d.svg";